import { get } from "lodash";
import { useState } from "react";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { REFERENTIAL_TYPES } from "utils/constants";

const useColumnsConfig = (user) => {
  const userId = get(user, "id");
  const [referentialId, setReferentialId] = useState(null);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [addReferential] = useMutation(graphql.mutations.ADD_REFERENTIAL);
  const [updateReferential] = useMutation(graphql.mutations.UPDATE_REFERENTIAL);

  const { loading } = useQuery(graphql.queries.REFERENTIAL, {
    skip: !userId,
    fetchPolicy: "no-cache",
    variables: {
      where: {
        type: REFERENTIAL_TYPES.PROJECTS_LIST_COLUMNS,
        user: { id: userId },
      },
    },
    onCompleted: ({ referential }) => {
      if (!referential) return;
      setReferentialId(referential.id);
      setHiddenColumns(get(referential, "entries.hiddenColumns", []));
    },
  });

  const saveHiddenColumns = (nextHiddenColumns) => {
    setHiddenColumns(nextHiddenColumns);
    const entries = { hiddenColumns: nextHiddenColumns };
    if (referentialId) {
      return updateReferential({
        variables: { where: { id: referentialId }, data: { entries } },
      });
    }
    return addReferential({
      variables: {
        data: {
          name: REFERENTIAL_TYPES.PROJECTS_LIST_COLUMNS,
          type: REFERENTIAL_TYPES.PROJECTS_LIST_COLUMNS,
          user: { id: userId },
          entries,
        },
      },
      onCompleted: ({ addReferential: created }) =>
        setReferentialId(get(created, "id")),
    });
  };

  return { hiddenColumns, saveHiddenColumns, loading };
};

export default useColumnsConfig;
